<template>
  <div>
    <el-card shadow="nerver">
      <el-breadcrumb separator="/">
        <!-- separator 分隔符 -->
        <el-breadcrumb-item :to="{ name: 'check_list' }">返回</el-breadcrumb-item>
        <el-breadcrumb-item>新建清单</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <!-- 添加和新建 -->
    <el-card class="add_poi_form"
             shadow="never">
      <!-- 添加条目 -->
      <el-form :inline="true"
               :model="postCheckItem"
               class="demo-form-inline">
        <el-form-item label="分类">
          <el-select v-model="postCheckItem.item_class"
                     size="mini"
                     placeholder="条目分类">
            <el-option v-for="item in check_list_class"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>

        </el-form-item>
        <el-form-item label="条目名称">
          <el-input v-model="postCheckItem.item_name"
                    size="mini"
                    placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="postCheckItem.item_remark"
                    size="mini"
                    placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="链接:">
          <el-input v-model="postCheckItem.link"
                    size="mini"
                    placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="商品优势(可选：好物推荐、折扣购、必备、优选等):">
          <el-input v-model="postCheckItem.link_info"
                    size="mini"
                    placeholder=""></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     size="mini"
                     @click="onSubmit">添加</el-button>
        </el-form-item>
      </el-form>
      <!-- 表头 -->
      <!-- 条目列表：可单选 -->
      <div v-for="class_item in check_item_data"
           :key="class_item.id">
        <div v-if="class_item.child.length !== 0">
          <div class="check_list_class_name">{{class_item.name}}</div>
          <!-- 表格 -->
          <el-table ref="multipleTable"
                    :show-header="false"
                    :data="class_item.child"
                    @select="handleSelectionChange"
                    tooltip-effect="dark"
                    style="width: 100%">
            <el-table-column type="selection"
                             width="55">
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">{{ scope.row.item_name }}</template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">{{ scope.row.item_remark }}</template>
            </el-table-column>
            <el-table-column prop="name">
              <template slot-scope="scope">{{ scope.row.item_link }}</template>
            </el-table-column>
            <el-table-column prop="address"
                             show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.item_link_info }}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div style="margin-top: 20px">
        <el-input type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  placeholder="请输入清单说明"
                  v-model="remark">
        </el-input>
      </div>
      <div style="margin-top: 20px">

        <el-button size="mini"
                   type="primary"
                   @click="createdCheckList()">新建行李清单</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'check_list_add',
  data() {
    return {
      // 全部条目
      check_item_data: [],
      // 选择的条目 ji 类别
      check_list_class: [],
      postCheckItem: {},
      tableData: [],
      remark: '',
    }
  },
  mounted() {
    this.getCheckListClass()
    this.getCheckListItem()
  },
  methods: {
    // 获取分类
    getCheckListClass() {
      this.$http.get(`/traver/get_check_list_class`).then((res) => {
        if (res.data.errno == '0') {
          this.check_list_class = res.data.data
        } else {
          this.$message({
            type: 'error',
            message: res.data.errmsg,
          })
        }
      })
    },
    // 提交条目
    onSubmit() {
      this.$http
        .post(`/traver/post_check_list_item`, this.postCheckItem)
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            this.$message({
              type: 'success',
              message: res.data.errmsg,
            })
            // 刷新
            this.getCheckListItem()
            this.postCheckItem = {}
          } else {
            this.$message({
              type: 'error',
              message: res.data.errmsg,
            })
          }
        })
    },
    getCheckListItem() {
      this.$http.get('/traver/get_check_list_item').then((res) => {
        console.log(res)
        if (res.data.errno == '0') {
          this.check_item_data = res.data.data
        }
      })
    },
    handleSelectionChange(val, row) {
      console.log(row)

      this.check_list_class.forEach((item) => {
        if (item.id == row.item_class) {
          item.child.push(row)
        }
      })
    },
    selectionChange(val) {
      // console.log(val)
    },
    createdCheckList() {
      console.log(this.check_list_class)
      this.$prompt('请输入行李清单名称', '创建旅行清单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          // 发送请求
          let check_list_post = {
            check_list_name: value,
            check_list: this.check_list_class,
            remark: this.remark,
          }
          this.$http
            .post(`/traver/created_check_list`, check_list_post)
            .then((res) => {
              if (res.data.errno == '0') {
                this.$message({
                  type: 'success',
                  message: res.data.errmsg,
                })
                this.$router.push('/check_list')
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.errmsg,
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消创建',
          })
        })
    },
  },
}
</script>


<style>
.check_list_class_name {
  background-color: #ffbeaa;
  /* text-align: center; */
  padding: 5px 10px;
  font-size: 15px;
  border-radius: 10px;
}
</style>